import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    lang: 'en-US',
    messagess: 'es-US'
}

// export const name = 'lang'

const langSlice = createSlice({
    name: 'lang',
    initialState,
    reducers:{
        setLang(state,payload){
            state.lang = payload.payload
        },
        setMessages(state,payload){
            state.messagess = payload.payload
        }
    }
})

export const { actions, reducer } = langSlice
export const getLang = (state) => state.lang.lang
export const getMessages = (state) => state.lang.messagess